export default "__VITE_ASSET__4v5RXkhv__"